import { AfterViewInit, Component, DestroyRef, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ContactRequest } from '../../requests/ContactRequest';
import { BaseResponse } from '../../responses/BaseResponse';
import { ContactService } from '../services/ContactService';
import { AlertService } from '../services/alert-service';
import { Status } from '../../utilities/Status';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MainMenuComponent, SubscribeComponent],
  templateUrl: '../templates/contact.component.html',
  styleUrl: '../css/contact.component.css'
})
export class ContactComponent implements AfterViewInit, OnDestroy {


  // to display loader when request sends to the server
  isLoad: boolean = false;
  //form names
  contactUsForm!: FormGroup;

  //variable declaration
  buttonText = 'Submit';
  title = 'Add';

  //service-call to insert contacts
  contactRequest!: ContactRequest;
  touristResponse!: BaseResponse;
  private readonly destroyRef = inject(DestroyRef);

  //to check whether form is submitted or not
  isFormSubmitted = false;

  constructor(private readonly scriptLoader: ScriptLoaderService,
    private _fb: FormBuilder,
    private _contactService: ContactService,
    private _alertService: AlertService) {}
  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }


  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  ngOnInit() {
    this.contactUsForm = this._fb.group({
      firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z ]+$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z ]+$')]],
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      emailAddress: ['', [Validators.required, Validators.email]],
      message: []
    });
  }

  onNewCatering() {
    this.resetContactFormState();
    this.buttonText = 'Submit';
    this.title = 'Add';
  }

  private resetContactFormState() {
    this.contactUsForm.reset();
    this.contactUsForm.markAsPristine();
    this.contactUsForm.markAsUntouched();
    this.isFormSubmitted = false;
  }

  //Methods for validation
  isFieldValid(field: string) {
    return (
      (!this.contactUsForm.get(field)!.valid && this.contactUsForm.get(field)!.touched) ||
      (this.contactUsForm.get(field)!.untouched && this.isFormSubmitted)
    );
  }
  onSubmit() {
    this.isFormSubmitted = true;
    if (this.contactUsForm.invalid) {
      this.contactUsForm.markAllAsTouched();
      return;
    }

    this.isLoad = true;
    this.contactRequest = {
      FirstName: this.contactUsForm.controls['firstName'].value,
      LastName: this.contactUsForm.controls['lastName'].value,
      ContactNumber: this.contactUsForm.controls['phoneNumber'].value,
      EmailAddress: this.contactUsForm.controls['emailAddress'].value,
      Message: this.contactUsForm.controls['message'].value,
      Website: 'ssdc'
    };

    this.touristResponse = new BaseResponse();
    this._contactService.insertContact(this.contactRequest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data:any) => {
          this.touristResponse = data;
          if (this.touristResponse.Status == Status.Yes) {
            this._alertService.showSuccess(this.touristResponse.Message, 'Contact');
            this.resetContactFormState();
            document.getElementById('close')?.click();
          }
          else {
            this._alertService.showError(this.touristResponse.Message, 'Contact');
          }
          this.isLoad = false;
        },
        error: (error:any) => {
          const errorMessage = error?.error?.message || error?.message || 'Unable to submit contact details. Please try again.';
          this._alertService.showError(errorMessage, 'Contact');
          this.isLoad = false;
        }
      });
  }
}
